export default __webpack_public_path__ + "281ad8055d92956dcc7d98268835890c.gif";